import { ModuleManifest } from "shared/bootstrap";
import publicLocale from "./i18n/public.json";
import storeMod from "./store";

export interface Config {
  contact: boolean;
}

function loadConfig(c: Partial<Config> = {}): Config {
  return {
    contact: true,
    ...c,
  };
}

export default function (c?: Partial<Config>): ModuleManifest {
  const config = loadConfig(c);

  return {
    menuItems: [
      {
        to: { name: "my-data" },
        title: "relationprofile.menuItems.myData",
        icon: "users",
        hideNoAuth: true,
      },
    ],
    routes: [
      {
        path: "/mijn-gegevens",
        name: "my-data",
        meta: {
          auth: true,
          title: "relationprofile.menuItems.myData",
          contact: config.contact,
        },
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import("./pages/MyData.vue"),
      },
    ],
    storeModules: {
      relationprofile: storeMod,
    },
    widgets: [
      {
        name: "UserInfo",
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import("./widgets/UserInfo.vue"),
      },
    ],
    localisation: { key: "relationprofile", messages: publicLocale },
  };
}
